import React from 'react';
import { useState } from 'react';
import { Button, Divider, Typography } from '@material-ui/core';
import LocalLoginForm from './LocalLoginForm';
import LdapLoginForm from './LdapLoginForm';
import FreeTrialButton from './FreeTrialButton';
import DividerWithText from '../util/DividerWithText';
import { IS_PARATOOLS_DEMO } from '@config';
import OidcLoginForm from './OidcLoginForm';

const CustomButton = ({ text, onClick, style }) => (
    <Button
        variant="outlined"
        style={{
            borderColor: 'grey',
            borderWidth: '1px',
            color: 'black',
            margin: '10px 0',
            textTransform: 'none',
            boxShadow: 'none',
            transition: 'background-color 0.3s',
            ...style,
        }}
        fullWidth
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#eaeaea')}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
        onClick={onClick}
    >
        {text}
    </Button>
);

const LoginTab = ({ props, setRecoverPassword, recoverPassword, reg }) => {
    const [selectedLoginForm, setSelectedLoginForm] = useState('local');
    const LoginForm = () => {
        switch (selectedLoginForm) {
            case 'local':
                return (
                    <>
                        <LocalLoginForm {...props} setRecoverPassword={setRecoverPassword} recoverPassword={recoverPassword} />
                        {!recoverPassword && (
                            <>
                                <DividerWithText text="Or" style={{ margin: '30px 0' }} />
                                <CustomButton text="Log in with LDAP" onClick={() => setSelectedLoginForm('ldap')} />
                                <CustomButton text="Log in with OpenID Connect" onClick={() => setSelectedLoginForm('oidc')} />
                            </>
                        )}
                    </>
                );
            case 'ldap':
                return <LdapLoginForm setSelectedLoginForm={setSelectedLoginForm} />;
            case 'oidc':
                return <OidcLoginForm setSelectedLoginForm={setSelectedLoginForm} />;
        }
    }
    return (
        <>
            <LoginForm />
            {reg && (
                <>
                    {!recoverPassword && <Divider className="my-16" />}
                    <div className="flex flex-col items-start w-full">
                        {!recoverPassword && (
                            <React.Fragment>
                                <div className="flex flex-col items-start justify-center w-full pt-16">
                                    {IS_PARATOOLS_DEMO && <FreeTrialButton />}
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </>
            )}
        </>
    );
}


export default LoginTab;